import {Children, ClassComponent, Vnode} from 'mithril';
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Placeholder from 'flarum/common/components/Placeholder';
import AlbumThumbnail from './AlbumThumbnail';
import AlbumListState from '../states/AlbumListState';

const translationPrefix = 'kilowhat-cimaise.forum.album-list.';

interface AlbumListAttrs {
    state: AlbumListState
}

export default class AlbumList implements ClassComponent<AlbumListAttrs> {
    view(vnode: Vnode<AlbumListAttrs>) {
        const {state} = vnode.attrs;

        let loading: Children;

        if (state.loading) {
            loading = LoadingIndicator.component();
        } else if (state.moreResults) {
            loading = Button.component({
                className: 'Button',
                onclick: state.loadMore.bind(state),
            }, app.translator.trans(translationPrefix + 'load-more'));
        }

        if (state.albums.length === 0 && !state.loading) {
            return Placeholder.component({
                text: app.translator.trans(translationPrefix + 'empty'),
            });
        }

        return m('div', [
            m('.AlbumPictureList', state.albums.map(album => m(AlbumThumbnail, {
                album,
                ondelete: () => {
                    state.removeAlbum(album);
                },
                showUser: true,
            }))),
            loading,
        ]);
    }
}
